export default function Content1Icon() {
  return (
    <svg
      width="102"
      height="102"
      viewBox="0 0 102 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M50.964 100.992C78.5584 100.992 100.928 78.6064 100.928 50.9922C100.928 23.3779 78.5584 0.992188 50.964 0.992188C23.3697 0.992188 1 23.3779 1 50.9922C1 78.6064 23.3697 100.992 50.964 100.992Z"
        fill="#F1F3F9"
        stroke="#D6DCE8"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M93.9671 87.3558H7.6417C5.49046 87.3558 3.72534 85.6155 3.72534 83.4945V17.5807C3.72534 15.4597 5.49046 13.7194 7.6417 13.7194H93.9671C96.1183 13.7194 97.8834 15.4597 97.8834 17.5807V83.4945C97.8834 85.6155 96.1183 87.3558 93.9671 87.3558Z"
        fill="white"
        stroke="#D6DCE8"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M89.9407 61.7983H11.117C9.84833 61.7983 8.80029 60.7495 8.80029 59.4799V35.5784C8.80029 34.3088 9.84833 33.26 11.117 33.26H89.9407C91.2093 33.26 92.2574 34.3088 92.2574 35.5784V59.4247C92.2574 60.7495 91.2093 61.7983 89.9407 61.7983Z"
        fill="#F1F3F9"
      />
      <mask
        id="mask0_100_50447"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="8"
        y="33"
        width="85"
        height="29"
      >
        <path
          d="M89.9407 61.7983H11.117C9.84833 61.7983 8.80029 60.7495 8.80029 59.4799V35.5784C8.80029 34.3088 9.84833 33.26 11.117 33.26H89.9407C91.2093 33.26 92.2574 34.3088 92.2574 35.5784V59.4247C92.2574 60.7495 91.2093 61.7983 89.9407 61.7983Z"
          fill="#F1F3F9"
        />
      </mask>
      <g mask="url(#mask0_100_50447)">
        <path
          d="M78.6876 63.4542H22.3693V39.9391C22.3693 39.0559 23.0863 38.3383 23.9689 38.3383H77.088C77.9705 38.3383 78.6876 39.0559 78.6876 39.9391V63.4542Z"
          fill="white"
          stroke="#D6DCE8"
          stroke-width="2"
          stroke-miterlimit="10"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30.4785 47.5017C30.4785 47.1968 30.7255 46.9497 31.0301 46.9497H45.1511C45.4557 46.9497 45.7027 47.1968 45.7027 47.5017C45.7027 47.8066 45.4557 48.0537 45.1511 48.0537H31.0301C30.7255 48.0537 30.4785 47.8066 30.4785 47.5017Z"
        fill="#AAB2C5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30.4785 51.0896C30.4785 50.7847 30.7255 50.5376 31.0301 50.5376H40.5728C40.8774 50.5376 41.1244 50.7847 41.1244 51.0896C41.1244 51.3945 40.8774 51.6416 40.5728 51.6416H31.0301C30.7255 51.6416 30.4785 51.3945 30.4785 51.0896Z"
        fill="#AAB2C5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30.4785 54.1806C30.4785 53.8757 30.7255 53.6286 31.0301 53.6286H69.6973C70.0019 53.6286 70.2489 53.8757 70.2489 54.1806C70.2489 54.4855 70.0019 54.7326 69.6973 54.7326H31.0301C30.7255 54.7326 30.4785 54.4855 30.4785 54.1806Z"
        fill="#AAB2C5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30.4785 57.3823C30.4785 57.0775 30.7255 56.8304 31.0301 56.8304H69.6973C70.0019 56.8304 70.2489 57.0775 70.2489 57.3823C70.2489 57.6872 70.0019 57.9343 69.6973 57.9343H31.0301C30.7255 57.9343 30.4785 57.6872 30.4785 57.3823Z"
        fill="#AAB2C5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30.4785 60.5839C30.4785 60.2791 30.7255 60.0319 31.0301 60.0319H69.6973C70.0019 60.0319 70.2489 60.2791 70.2489 60.5839C70.2489 60.8888 70.0019 61.1359 69.6973 61.1359H31.0301C30.7255 61.1359 30.4785 60.8888 30.4785 60.5839Z"
        fill="#AAB2C5"
      />
      <path
        d="M71.958 25.9186H23.5827C22.9207 25.9186 22.3691 25.4816 22.3691 24.9573V23.4281C22.3691 22.9038 22.9207 22.4669 23.5827 22.4669H71.958C72.6199 22.4669 73.1715 22.9038 73.1715 23.4281V24.9573C73.2267 25.4816 72.675 25.9186 71.958 25.9186Z"
        fill="#AAB2C5"
      />
      <path
        d="M91.3748 72.231H23.2522C22.7557 72.231 22.3145 71.9525 22.3145 71.5545V70.5598C22.3145 70.2016 22.7006 69.8833 23.2522 69.8833H91.3196C91.816 69.8833 92.2573 70.1618 92.2573 70.5598V71.5545C92.2573 71.9525 91.8712 72.231 91.3748 72.231Z"
        fill="#AAB2C5"
      />
      <path
        d="M68.0972 79.131H23.2522C22.7557 79.131 22.3145 78.8524 22.3145 78.4545V77.4597C22.3145 77.1016 22.7006 76.7833 23.2522 76.7833H68.0421C68.5385 76.7833 68.9798 77.0618 68.9798 77.4597V78.4545C68.9798 78.8127 68.5937 79.131 68.0972 79.131Z"
        fill="#AAB2C5"
      />
      <path
        d="M16.2469 28.2369H10.1241C9.40705 28.2369 8.80029 27.6297 8.80029 26.9121V20.7298C8.80029 20.0122 9.40705 19.405 10.1241 19.405H16.2469C16.964 19.405 17.5707 20.0122 17.5707 20.7298V26.8569C17.5707 27.6297 16.964 28.2369 16.2469 28.2369Z"
        fill="#F1F3F9"
      />
      <path
        d="M13.7647 79.1309C11.0067 79.1309 8.80029 76.923 8.80029 74.163C8.80029 71.403 11.0067 69.195 13.7647 69.195C16.5227 69.195 18.7291 71.403 18.7291 74.163C18.7291 76.8678 16.5227 79.1309 13.7647 79.1309Z"
        fill="#D6DCE8"
      />
      <path
        d="M16.7428 76.7022C15.9706 75.9294 15.2535 75.4878 13.7642 75.4878C12.2197 75.4878 11.5578 75.9846 10.7855 76.7022C11.5026 77.5302 12.6058 78.0822 13.8193 78.0822C14.9225 78.0822 15.9154 77.6406 16.6325 76.923C16.6325 76.8678 16.7428 76.8126 16.7428 76.7022C16.798 76.7022 16.7428 76.7022 16.7428 76.7022Z"
        fill="white"
      />
      <path
        d="M13.7638 74.5494C14.6777 74.5494 15.4186 73.808 15.4186 72.8934C15.4186 71.9788 14.6777 71.2374 13.7638 71.2374C12.8499 71.2374 12.109 71.9788 12.109 72.8934C12.109 73.808 12.8499 74.5494 13.7638 74.5494Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.8606 21.9166H10.2894V21.0886H15.8606V21.9166Z"
        fill="#AAB2C5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.8606 24.1246H10.2894V23.2966H15.8606V24.1246Z"
        fill="#AAB2C5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.0955 26.3326H10.2894V25.5046H14.0955V26.3326Z"
        fill="#AAB2C5"
      />
    </svg>
  );
}
